/* eslint-disable unicorn/filename-case */
import GuestBanner from '../../components/GuestBanner'
import { WebWrapper } from '../../components/WebWrapper'

import { WalletScreen } from './Wallet'

export default () => (
  <>
    <GuestBanner />
    <WebWrapper>
      <WalletScreen />
    </WebWrapper>
  </>
)
